import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import { usePricingVariationsSales } from "./hooks/usePricingVariationsSales";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "pricingVariationSalesReport.info.title",
  rows: ["pricingVariationSalesReport.info.note"],
};

const PricingVariationsSales = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = usePricingVariationsSales(requestParams);

  const tableDataEmpty = !isLoading && !data?.reportData?.length;

  const tableData = useMemo(
    () =>
      data?.reportData.map((data) => ({
        clinic: data.clinic,
        inventoryVariation: data.package,
        noSales: data.no_of_sales,
        totalSales: data.total_sales_of_amount,
        balanceAmount: data.balance_amount,
      })),
    [data],
  );

  const clinics =
    useMemo(
      () =>
        data?.clinics.map((clinic) => ({
          label: clinic.clinic_name,
          value: clinic.id,
        })),
      [data],
    ) || [];

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Pricing Variations Sales"
        selectedClinic={selectedClinic}
        clinics={clinics}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getIvPackageSales()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic", accessor: "clinic" },
              { data: "Invetory Variation", accessor: "inventoryVariation" },
              { data: "No. of Sales", accessor: "noSales" },
              { data: "Total Sales", accessor: "totalSales" },
              { data: "Balance Amount", accessor: "balanceAmount" },
            ]}
            data={tableData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {tableDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingVariationsSales;
